import React from 'react';
import { Button } from '@economic/taco';
import { t } from '@lingui/macro';
import ExternalLink from '../../shared/components/ExternalLink';
import { t as t2, tBB } from '../../shared/components/l10n/l10n';
import iconLearn from './iconLearn.svg';
import iconLightbulb from './iconLightbulb.svg';
import iconRead from './iconRead.svg';
import success from './onboarding_getstarted.png';

interface Props {
    onDone: () => void;
    isRackbeatStepVisible: boolean | undefined;
    isInterestedInRackbeat: boolean | undefined;
}

export default function StepSuccess({ onDone, isRackbeatStepVisible, isInterestedInRackbeat }: Props) {
    function getSuccessMessageContent() {
        if (isRackbeatStepVisible) {
            if (isInterestedInRackbeat) {
                return t`Your agreement is ready to use, and you will now be taken to Storage by Rackbeat.`;
            }
            return tBB(
                t`Your agreement is ready to use! Fill out the contact form in the new tab and you will be contacted. Don't see it? Click [LINK]rackbeat[/LINK].`,
                {
                    __LINK: () => (
                        <ExternalLink href="https://www.e-conomic.dk/funktioner/lager-af-rackbeat#kontakt">here</ExternalLink>
                    ),
                }
            );
        }
        return t2`ONBOARDING_GETTINGSTARTED_SUCCESS_CONTENT`;
    }

    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding onboarding__success">
                <img src={success} alt="" className="onboarding__picture" />

                <h2>{t2`ONBOARDING_GETTINGSTARTED_SUCCESS_TITLE`}</h2>

                <p>{getSuccessMessageContent()}</p>

                <Button appearance="primary" onClick={onDone}>
                    {isInterestedInRackbeat
                        ? t`Start e-conomic and go to Lager by Rackbeat`
                        : t2`ONBOARDING_GETTINGSTARTED_SUCCESS_CTA`}
                </Button>

                <div className="bottom-panel">
                    <div>
                        <img src={iconRead} alt="" className="mx-auto" />
                        <p className="text-center">
                            {tBB(`ONBOARDING_GETTINGSTARTED_SUCCESS_TIP1`, {
                                __LINK: content => (
                                    <ExternalLink href="https://www.e-conomic.dk/support/e-copedia">{content}</ExternalLink>
                                ),
                            })}
                        </p>
                    </div>
                    <div>
                        <img src={iconLightbulb} alt="" className="mx-auto" />
                        <p className="text-center">
                            {tBB('ONBOARDING_GETTINGSTARTED_SUCCESS_TIP2', {
                                __LINK: content => (
                                    <ExternalLink href="https://www.e-conomic.dk/support/kom-godt-i-gang">{content}</ExternalLink>
                                ),
                            })}
                        </p>
                    </div>
                    <div>
                        <img src={iconLearn} alt="" className="mx-auto" />
                        <p className="text-center">
                            {tBB(`ONBOARDING_GETTINGSTARTED_SUCCESS_TIP3`, {
                                __LINK: content => (
                                    <ExternalLink href="https://www.e-conomic.dk/support/online-kurser">{content}</ExternalLink>
                                ),
                            })}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
